import React, {Fragment, useEffect, useRef, useState} from 'react';
import {FormattedMessage} from "react-intl";
import database from "../../../../utils/databaseFirebase";
import RoleForm from "./roleForm";
import {IconButton, Spinner} from "../../../shared";
import functions from "../../../../utils/functionsFirebase";

function RolesMenu({group, hasRightManageRoles, roles, setRoles}) {

    const [editingRole, setEditingRole] = useState({roleName: "", publishFiles: true});
    const [openForm, setOpenForm] = useState(false);
    const [validRole, setValidRole] = useState(false);

    const roleFormRef = useRef();
    const openFormButton = useRef();

    const [loadingSaveRole, setLoadingSaveRole] = useState(false);

    useEffect(() => {
        if (group) {
            resetEditingRole();

            const groupRolesRef = database.ref('/groupRoles/')
                .orderByChild('groupId')
                .equalTo(group.id);

            // Set up a listener for changes
            groupRolesRef.on('child_added', snapshot => {
                if(roles.some(x => x.id === snapshot.key)){
                    return;
                }
                const newRole = snapshot.val();
                newRole.id = snapshot.key;
                if(roles.some(x => x.id === newRole.id)){
                    return;
                }
                setRoles(prevRoles => {
                    const aux = [...prevRoles];
                    aux.push(newRole);
                    aux.sort((a, b) => a.roleName.localeCompare(b.roleName));
                    group.roles = aux;
                    return aux;
                });
            });
            groupRolesRef.on('child_changed', snapshot => {
                const newRole = snapshot.val();
                newRole.id = snapshot.key;
                setRoles(prevRoles => {
                    const aux = [...prevRoles];
                    const editedRoleIndex = aux.findIndex(x => x.id === newRole.id);
                    aux.splice(editedRoleIndex, 1);
                    aux.push(newRole);
                    aux.sort((a, b) => a.roleName.localeCompare(b.roleName));
                    group.roles = aux;
                    return aux;
                })
            });
            groupRolesRef.on('child_removed', snapshot => {
                setRoles(prevRoles => {
                    const aux = [...prevRoles];
                    const deletedRoleIndex = aux.findIndex(x => x.id === snapshot.key);
                    aux.splice(deletedRoleIndex, 1);
                    group.roles = aux;
                    return aux;
                })
            });

            return () => {
                groupRolesRef.off('child_added');
                groupRolesRef.off('child_changed');
                groupRolesRef.off('child_removed');
            }
        }

    }, [group?.id]);

    const resetEditingRole = () => {
        setEditingRole({roleName: "", publishFiles: true, everyone: false});
    }

    const toggleOpenFormRole = () => {
        setOpenForm(!openForm);
        if (!openForm) {
            resetEditingRole();
        }
    }

    const saveRole = async () => {
        setLoadingSaveRole(true);
        await roleFormRef.current.saveRole();
        toggleOpenFormRole();
        setLoadingSaveRole(false);
    }

    const deleteRole = async (role) => {
        const deleteRoleFunct = functions.httpsCallable('deleteRole');
        await deleteRoleFunct({role});
    }

    return (
        <div>
            {hasRightManageRoles &&
                <Fragment>
                    {!openForm && <div className="d-grid">
                        <button className="btn btn-secondary" type="button" data-bs-toggle="collapse"
                                onClick={() => toggleOpenFormRole()} ref={openFormButton}
                                data-bs-target="#collapseRoleForm" aria-expanded="false"
                                aria-controls="collapseRoleForm">
                            <FormattedMessage id="roles.create-role"/>
                        </button>
                    </div>}
                    {openForm && <div className="col-12">
                        <button className="btn btn-danger col-6" type="button" data-bs-toggle="collapse"
                                onClick={() => toggleOpenFormRole()} disabled={loadingSaveRole}
                                data-bs-target="#collapseRoleForm" aria-expanded="false"
                                aria-controls="collapseRoleForm">
                            <FormattedMessage id="modal.cancel"/>
                        </button>
                        <button className="btn btn-success col-6" type="button" data-bs-toggle="collapse"
                                onClick={() => saveRole()} disabled={!validRole || loadingSaveRole}
                                data-bs-target="#collapseRoleForm" aria-expanded="false"
                                aria-controls="collapseRoleForm">
                            <FormattedMessage id="app.save-changes"/>
                        </button>
                    </div>}
                    <div className="collapse" id="collapseRoleForm">
                        <div className="card card-body">
                            <RoleForm role={editingRole} setValidRole={value => setValidRole(value)} groupId={group.id}
                                      ref={roleFormRef}/>
                        </div>
                    </div>
                    <div className="d-flex flex-row justify-content-center mt-3">
                        {loadingSaveRole && <Spinner/>}
                    </div>
                </Fragment>}

            <div>
                <ul className="list-group list-group-flush">
                    {roles.map((role) => (
                        <li className="list-group-item d-flex flex-row justify-content-between" key={role.id}>
                            <span>
                                {role.roleName}
                                {role.administrator && <i className="fa-solid fa-a ms-2 text-warning" title="Admin"></i>}
                                {role.everyone && <i className="fa-solid fa-users ms-2" title="@everyone"></i>}
                            </span>
                            <div className="d-flex flex-row justify-content-between">
                                <IconButton icon="fa-solid fa-pen-to-square"
                                            onClick={() => {
                                                if(openFormButton?.current) {
                                                    openFormButton.current.click();
                                                    setEditingRole(role);
                                                }
                                            }}/>

                                {!role.everyone && <IconButton icon="fa-solid fa-trash"
                                             className="text-danger ms-2"
                                             onClick={() => deleteRole(role)}/>}
                                {role.everyone && <div className="ms-2" style={{width: "14px"}}></div>}
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default RolesMenu;
